import React, { createContext, useContext, useState, useEffect } from 'react';

const AdminAuthContext = createContext();

export const useAdminAuth = () => {
  const context = useContext(AdminAuthContext);
  if (!context) {
    throw new Error('useAdminAuth must be used within AdminAuthProvider');
  }
  return context;
};

export const AdminAuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    const saved = localStorage.getItem('admin_authenticated');
    const expiry = localStorage.getItem('admin_auth_expiry');
    if (saved === 'true' && expiry) {
      return new Date().getTime() < parseInt(expiry);
    }
    return false;
  });

  const login = (password) => {
    // Admin password
    const ADMIN_PASSWORD = 'Nadinessence1!';
    
    if (password === ADMIN_PASSWORD) {
      setIsAuthenticated(true);
      localStorage.setItem('admin_authenticated', 'true');
      // Session expires in 24 hours
      localStorage.setItem('admin_auth_expiry', (new Date().getTime() + 24 * 60 * 60 * 1000).toString());
      return true;
    }
    return false;
  };

  const logout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('admin_authenticated');
    localStorage.removeItem('admin_auth_expiry');
  };

  // Check expiry periodically
  useEffect(() => {
    const interval = setInterval(() => {
      const expiry = localStorage.getItem('admin_auth_expiry');
      if (expiry && new Date().getTime() >= parseInt(expiry)) {
        logout();
      }
    }, 60000); // Check every minute

    return () => clearInterval(interval);
  }, []);

  return (
    <AdminAuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
};
